export default [
  {
    path: "pudo",
    name: "pudo",
    component: () => import("@/views/JoinUs/Pudo/index.vue"),
    meta: {
      title: "成为我们的PUDO站点",
    },
  },
  {
    path: "franquia",
    name: "franquia",
    component: () => import("@/views/JoinUs/Franquia/index.vue"),
    meta: {
      title: "成为我们的加盟商",
    },
  },
];
